import { compareVersions } from "./compareVersions"
import { APP_VERSION } from "./constants"
import * as versions from "./versions"

export const doesAppSupport = (version: keyof typeof versions) => {
  if (APP_VERSION === undefined) return false
  return compareVersions(versions[version], APP_VERSION) >= 0
}
